export const ERROR_PROJECT_UNPAID = 101;
export const ERROR_PERMISSION_DENIED = 102;
export const ERROR_INVALID_TOKEN = 103;
export const ERROR_PROJECT_ID_MISSING = 105;
export const ERROR_RESOURCE_NOT_FOUND = 106;
